
class Logout {

    constructor(el = {}) {
        this.logout = this.logout.bind(this);
        this.logoutOidc = this.logoutOidc.bind(this);
        const logoutBtn = document.querySelector('.button__Logout');
        const logoutOidcBtn = document.querySelector('.button__Logout--oidc');
        if (logoutBtn) {
            logoutBtn.addEventListener('click', this.logout);
        }
        if(logoutOidcBtn) {
            logoutOidcBtn.addEventListener('click', this.logoutOidc);
        }
    }

    getBranchName() {
        const branchBtn = document.querySelector('.header__toolbar-button');
        if (!branchBtn) return
        let branchName = branchBtn.innerText
        return branchName.toUpperCase().includes('BRANSCH') ? "no_branch" : branchName.charAt(0).toUpperCase() + branchName.slice(1).toLowerCase()
    }
    
    logoutOidc(e) {
        const loginType = e.currentTarget.dataset.loginType;
        dataLayer.push({
            'event': 'login',
            'loggedInType': loginType,
            'loggedInStatus': 'Logout',   // Login|Logout
            'selectedBranch': this.getBranchName()
        });
    }

    logout(e) {
        e.preventDefault();

        const loginType = e.currentTarget.dataset.loginType;
        dataLayer.push({
            'event': 'login',
            'loggedInType': loginType,
            'loggedInStatus': 'Logout',   // Login|Logout
            'selectedBranch': this.getBranchName()
        });

        fetch('/auth/logout', {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        }).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response;
            } else {
                var error = new Error(response.statusText);
                error.response = response;
                throw error;
            }
        }).then((response) => {
            return response.json();
        }).then((json) => {
            window.location = json.redirectUrl;
            //window.location = window.location;
        }).catch((ex) => {
            console.info(ex);
        });
    }
}

document.addEventListener("DOMContentLoaded", () => { new Logout(); });
